import { Block, Para, Bullets, Table } from '../print/PrintBlocks';
import { AnnotatedExample } from '../AnnotatedExample';
import { StructureDiagram } from '../StructureDiagram';
import { LivePreview } from '../LivePreview';
import { DoDont } from '../DoDont';
import { Badge } from '@/ui/base/badge';
import { STATUS_TONE } from '@/nucleo/statusBadgeTokens';
import { OS_DE_EXEMPLO } from '../exemplos';
import { ItemDaDocumentacao } from '../ItemDaDocumentacao';

export function PadroesAdminSection() {
  return (
    <div className="space-y-6">
      <ItemDaDocumentacao id="padroes-ordem">
        <Block>
          <Para>
            As telas administrativas seguem um roteiro fixo. Quem conhece uma listagem conhece
            todas: o título vem primeiro, avisos aparecem logo abaixo dele, indicadores refletem o
            universo total da entidade e os filtros afetam apenas a tabela.
          </Para>
          <StructureDiagram
            title="Ordem obrigatória de uma listagem"
            nodes={[
              { label: '1 · Cabeçalho da página', detail: 'título, descrição, ações principais' },
              { label: '2 · Avisos contextuais', detail: 'sempre abaixo do título, nunca acima' },
              { label: '3 · Indicadores', detail: 'números globais, independentes dos filtros' },
              {
                label: '4 · Busca e filtros',
                detail: 'limpar filtros só aparece quando há filtro ativo',
              },
              {
                label: '5 · Tabela',
                detail: 'seleção à esquerda, ações à direita, linha clicável',
              },
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="padroes-linha-clicavel">
        <Block title="Linha clicável nas listagens">
          <AnnotatedExample
            title="Exemplo de linha de Ordem de Serviço"
            annotations={[
              { text: 'A linha inteira abre o detalhe — não existe botão “Ver”.' },
              { text: 'Botões e links dentro da linha continuam funcionando normalmente.' },
              { text: 'A linha responde a teclado: Tab para focar, Enter ou Espaço para abrir.' },
              {
                text: 'A coluna de ações é sempre a última e some quando nenhum registro tem ação.',
              },
            ]}
          >
            <LivePreview surface="card">
              <div className="rounded-lg border border-border overflow-hidden">
                <div className="hidden sm:grid grid-cols-[1.2fr_1fr_1fr_auto] gap-3 bg-muted px-3 py-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
                  <span>Número</span>
                  <span>Condutor</span>
                  <span>Placa</span>
                  <span>Situação</span>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-[1.2fr_1fr_1fr_auto] gap-3 px-3 py-2.5 text-sm text-foreground hover:bg-accent/50 transition-colors cursor-pointer">
                  <span className="font-mono">{OS_DE_EXEMPLO.numero}</span>
                  <span>{OS_DE_EXEMPLO.condutor}</span>
                  <span className="font-mono">{OS_DE_EXEMPLO.placa}</span>
                  <Badge className={STATUS_TONE.success}>Vigente</Badge>
                </div>
              </div>
            </LivePreview>
          </AnnotatedExample>
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="padroes-indicadores-e-filtros">
        <Block title="Indicadores e filtros">
          <DoDont
            doText="Os indicadores mostram o total da entidade e permanecem estáveis enquanto o usuário filtra a tabela — servem de referência."
            dontText="Recalcular indicadores a cada filtro faz o usuário perder a noção do todo e transforma o painel em ruído."
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="padroes-regras-transversais">
        <Block title="Regras transversais">
          <Table
            head={['Regra', 'Aplicação']}
            rows={[
              ['Seleção em lote', 'Sempre a primeira coluna, não removível nem reordenável.'],
              ['Coluna de ações', 'Sempre a última coluna, não removível nem reordenável.'],
              [
                'Personalização da tabela',
                'Um único ícone discreto abre o painel de visualização, colunas e auditoria.',
              ],
              ['Datas', 'Sempre dia/mês/ano em português; meses por extenso quando houver espaço.'],
              [
                'Valores',
                'Sempre em reais formatados, com fonte monoespaçada para alinhar as casas decimais.',
              ],
              ['Avisos', 'Sempre no espaço reservado abaixo do título da página.'],
            ]}
          />
          <Bullets
            items={[
              'Modais densos ou de uso frequente em celular abrem como painel deslizante no mobile.',
              'Listas com mais de dez opções usam campo de busca com digitação, nunca uma lista rolável simples.',
              'Cartões de indicador só ganham realce ao passar o mouse quando forem realmente clicáveis.',
            ]}
          />
        </Block>
      </ItemDaDocumentacao>
    </div>
  );
}
